import styled from '@emotion/styled';

import { IconChecked } from 'components/icons/checked';

export const BadgeRow = styled.div({
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
});

export const CompleteBadge = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: 4,
  padding: '3px 6px',
  borderRadius: 5,
  border: '0.5px solid #ACDEB1',
  background: '#F3FAF3',
  boxShadow: '0 3px 12px 0 rgba(8, 155, 70, 0.08)',
});

export const CompleteIcon = styled(IconChecked)({
  color: '#00850D',
  width: 14,
  height: 14,
  flexShrink: 0,
});

export const ErrorBadge = styled.div((props) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 3,
  fontSize: 11,
  fontWeight: 500,
  fontFamily: props.theme.fonts.primary,
  color: props.theme.colors.error.main,
  backgroundColor: 'rgba(220, 53, 69, 0.08)',
  border: `1px solid ${props.theme.colors.error.main}`,
  borderRadius: 4,
  padding: '2px 6px',
  whiteSpace: 'nowrap',
}));
